class PullReveal {
  constructor(selector = '[data-pull-reveal]') {
    this.elements = document.querySelectorAll(selector);
    if (!this.elements.length) return;
    this.observe();
  }

  observe() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    this.elements.forEach((el) => {
      this.wrap(el);
      observer.observe(el.closest('.pull-reveal-wrapper'));
    });
  }

  wrap(el) {
    // Avoid double-wrapping
    if (el.closest('.pull-reveal-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('pull-reveal-wrapper');

    // Apply per-element overrides as CSS custom properties
    const duration = el.dataset.pullRevealDuration;
    const delay = el.dataset.pullRevealDelay;
    const easing = el.dataset.pullRevealEasing;

    if (duration) wrapper.style.setProperty('--pull-reveal-duration', `${duration}ms`);
    if (delay) wrapper.style.setProperty('--pull-reveal-delay', `${delay}ms`);
    if (easing) wrapper.style.setProperty('--pull-reveal-easing', easing);

    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
    el.classList.add('pull-reveal-inner');
  }

  reveal(wrapper) {
    wrapper.querySelector('.pull-reveal-inner').classList.add('is-revealed');
  }
}

document.addEventListener('DOMContentLoaded', () => new PullReveal());
